import styled from 'styled-components'

import { Button } from '@syconium/little-miss-figgy'

export const SubmitButton = styled(Button)``

export const FieldsWrap = styled.div`
  text-align: left;
`

export const TextContainer = styled.div`
  margin-top: 10px;
  text-decoration: underline;
  font-size: 12px;
  font-weight: 600;
  line-height: 20px;
  letter-spacing: 0.6px;
`

export const CreateAccountText = styled.span`
  font-weight: bold;
  font-size: 13px;
  line-height: 20px;
  letter-spacing: 2px;
  text-transform: uppercase;
`
export const CreateAccountTextWrapper = styled.div`
  display: inline;
  border-bottom: 2px solid ${o => o.theme.color.deprecated.obsidian};
`

export const OptionsButton = styled.button`
  color: ${o => o.theme.color.deprecated.obsidian};
  font-size: 11px;
`

export const Error = styled.div`
  color: red;
  font-size: 12px;
  margin-top: 10px;
`

export const SpaceBetween = styled.div`
  display: flex;
  justify-content: space-between;
`

export const PointerSpan = styled.span`
  cursor: pointer;
`

const redFG = '#c00'
const greenFG = '#0c8926'
const redBG = '#fff4f5'
const greenBG = '#e9feee'

export const PasswordReset = styled.div<{
  state: 'error' | 'success'
}>`
  background: ${o => (o.state === 'success' ? greenBG : redBG)};
  border: ${o => `1px solid ${o.state === 'success' ? greenFG : redFG}`};
  color: ${o => (o.state === 'success' ? greenFG : redFG)};
  padding: 15px;
  margin-bottom: 15px;
`

export const Underline = styled.span`
  text-decoration: underline;
`
